if (!window.customElements.get("component-pair-slider")) {

class PairSlider extends HTMLElement {

    constructor() {
      super();

      this.selectors = {
        swiper: "swiper-container"
      }

      this.slider = this.querySelector(this.selectors.swiper);
      this.initSlider();
    }

    initSlider() {
      const swiperParams = {
        spaceBetween: 16,
        slidesPerView: 1.2,
        breakpoints: {
            640: {
              slidesPerView: 1.8,
            },
            990: {
              slidesPerView: 2,
            }
          },
        on: {
          init() {
          }
        },
      };

      Object.assign(this.slider, swiperParams);

      this.slider.initialize();

    }
  }

  customElements.define('component-pair-slider', PairSlider);


}
